__turbopack_context__.v({
  "quoteActionsContainer": "QuoteActions-module-scss-module__CEHWKG__quoteActionsContainer",
});
